import { Point } from './Point.js';

// This class represents a polygon as an array of Point objects.
export class PointsPolygon {
  constructor(points = []) {
    this.points = points;
  }

  // This method returns the polygon in a format suitable for polygon-clipping:
  // [ [ [x1, y1], [x2, y2], ... ] ]
  // A single polygon with one ring (outer boundary).
  toClippingFormat() {
    const ring = this.points.map((p) => [p.x, p.y]);
    return [[ring]];
  }

  // This static method converts polygon-clipping output (array of polygons)
  // back into an array of Polygon objects with Point inside.
  // polygonClipping returns something like:
  // [ [ [ [x1, y1], [x2, y2], ... ] ], [ [ [x3, y3], ... ] ] ]
  // i.e. array of polygons, each polygon is array of rings, each ring is array of coords.
  static fromClippingFormat(clippingOutput) {
    // We expect clippingOutput to be an array of polygons.
    // We'll convert each polygon's first ring into a Polygon instance.
    const polygons = [];

    for (const poly of clippingOutput) {
      // poly is [ [ [x1, y1], [x2, y2], ... ], [ ... (holes) ] ]
      // We'll take the outer ring = poly[0]
      if (!poly.length) continue;
      const outerRing = poly[0];
      const points = outerRing.map(
        ([x, y]) => new Point(x, y)
      );
      polygons.push(new PointsPolygon(points));
    }
    return polygons;
  }
}
